import { components } from '@/types/api';

interface ReceiptFooterProps {
  receipt: components['schemas']['ReceiptOutput'];
  onRequestReview: () => void;
}

export default function ReceiptFooter({ receipt, onRequestReview }: ReceiptFooterProps) {
  return (
    <div className="space-y-4 px-4 py-6 text-center text-xs opacity-70">
      <p className="">
        Transaction ID: {receipt.id.substring(0, 3)}
        {receipt.id.substring(receipt.id.length - 3, receipt.id.length)}
      </p>
      {receipt.status !== 'finalized' && (
        <div className="text-center">
          <p className="mb-2 text-xs opacity-70">Something doesn't look quite right?</p>
          <button className="text-primary text-sm hover:text-teal-600" onClick={onRequestReview}>
            Request a review
          </button>
        </div>
      )}
    </div>
  );
}
